import CBT from "../assets/images/computer-setting.svg";
import Pastoral from "../assets/images/pastoral.svg";
import HR from "../assets/images/people2.svg";
import Finance from "../assets/images/half-circle.svg";
import Calendar from "../assets/images/calendar.svg";
import Eclassroom from "../assets/images/read-book.svg";
import Wallet from "../assets/images/wallet.svg";
import Report from "../assets/images/junior.svg";
import Admission from "../assets/images/students.svg";
import Mailbox from "../assets/images/message.svg";
import Medicals from "../assets/images/med.svg";
import Timetable from "../assets/images/timetable.svg";
import Lesson from "../assets/images/note.svg";
import Library from "../assets/images/lib.svg";
import Facility from "../assets/images/people.svg";
import Remarks from "../assets/images/remark.svg";
import Voting from "../assets/images/voting.svg";
import Clubs from "../assets/images/club.svg";
import Assignment from "../assets/images/assignment.svg";
import Daily from "../assets/images/daily.svg";

export const columeOne = [
  {
    title: "Finance",
    text: "A secure and reliable financial operations platform",
    icon: Finance,
    url: "/finance",
  },
  {
    title: "HR Manager",
    text: "Streamline your HR tasks with our comprehensive HR manager.",
    icon: HR,
    url: "/hrm",
  },
  {
    title: "Report",
    text: "Generate detailed school reports with ease using our user-friendly report.",
    icon: Report,
    url: "/report",
  },
  {
    title: "Calendar",
    text: "Stay organized and on schedule with our intuitive calendar platform.",
    icon: Calendar,
    url: "/calendar",
  },
];

export const columeTwo = [
  {
    title: "Pastoral",
    text: "Improve your institution’s pastoral care with our innovative software platform.",
    icon: Pastoral,
    url: "/pastoral",
  },
  {
    title: " CBT",
    text: "Revolutionize your testing process with our computer-based test platform.",
    icon: CBT,
    url: "/cbt",
  },
  {
    title: "eClassroom",
    text: "Versatile software platform designed to boost virtual learning and collaboration within schools.",
    icon: Eclassroom,
    url: "/e-classroom",
  },
  {
    title: "Wallet Manager",
    text: "Take control of your finances with our intuitive wallet manager platform.",
    icon: Wallet,
    url: "/wallet-manager",
  },
];

export const columeThree = [
  {
    title: "Students Admission",
    text: "Streamline admissions from inquiries to acceptance, strengthen efficiency and welcoming students with user-friendly, potent tools.",
    icon: Admission,
    url: "/admission",
  },
  {
    title: "MailBox",
    text: "Simplify communication with our powerful mailbox",
    icon: Mailbox,
    url: "/mail-box",
  },
  {
    title: "Medicals",
    text: "Streamline medical operations with our innovative software platform.",
    icon: Medicals,
    url: "/medicals",
  },
  {
    title: "Timetable",
    text: "Organize schedules with ease using our intuitive timetable platform.",
    icon: Timetable,
    url: "/timetable",
  },
];

export const columeFour = [
  {
    title: "Lesson Planner",
    text: "Streamline and facilitat your lesson planning process with our lesson planner..",
    icon: Lesson,
    url: "/lesson-planner",
  },
  {
    title: " Library",
    text: "Streamline your library management with our innovative software platform.",
    icon: Library,
    url: "/library",
  },
  {
    title: "Facility Management",
    text: "Optimize your workforce with our staff management platform..",
    icon: Facility,
    url: "/facility-manager",
  },
  {
    title: "Weekly remarks",
    text: "Effortlessly track performance with our weekly remarks platform.",
    icon: Remarks,
    url: "/weekly-remarks",
  },
];

export const columeFive = [
  {
    title: "Voting System",
    text: "Securely manage and conduct elections with our powerful voting system platform.",
    icon: Voting,
    url: "/voting-system",
  },
  {
    title: "Assignment",
    text: "Create assignments for Students in your school.",
    icon: Assignment,
    url: "/assignment",
  },
  {
    title: "Clubs",
    text: "Track and monitor your School activities outside core curriculum.",
    icon: Clubs,
    url: "/clubs",
  },
  {
    title: "Daily Reporting",
    text: "Submit daily reports, to keep track of updates in your organisation.",
    icon: Daily,
    url: "/daily-reporting",
  },
];

//data for businesses

export const columeSix = [
  {
    title: "Finance",
    text: "The one and only accounting and payroll solution your business will ever need.",
    icon: Finance,
    url: "/finance",
  },
  {
    title: "HR Manager",
    text: "Streamline your HR tasks with our comprehensive HR manager.",
    icon: HR,
    url: "/hrm",
  },
  {
    title: "Report",
    text: "Generate detailed school reports with ease using our user-friendly report.",
    icon: Report,
    url: "/report",
  },
  {
    title: "Calendar",
    text: "Stay organized and on schedule with our intuitive calendar platform.",
    icon: Calendar,
    url: "/calendar",
  },
];

export const columeSeven = [
  {
    title: "MailBox",
    text: "Ease communication with our powerful mailbox",
    icon: Mailbox,
    url: "/mailBox",
  },
  {
    title: "Medicals",
    text: "Streamline medical operations with our innovative software platform.",
    icon: Medicals,
    url: "/medicals",
  },
  {
    title: "Facility Management",
    text: "Optimize your workforce with our staff management platform..",
    icon: Facility,
    url: "/facility-manager",
  },
  {
    title: "Weekly remarks",
    text: "Effortlessly track performance with our weekly remarks platform.",
    icon: Remarks,
    url: "/weekly-remarks",
  },
];
